import { gql } from '@apollo/client';

const PRODUCT = gql`
  query Product($input: ProductInput!) {
    product(input: $input) {
      product {
        uuid
        name
        shortName
        slug
        numMemoryEstimates
        content {
          uuid
          slug
          summary
          parentUuid
          position
          availability
          name
          completedAt
          readingTimeMs
          numItems
        }
        price
        isPassFail
      }
    }
  }
`;

export default PRODUCT;
